<template>
    <div class="holder">
       
        <div class="flex flex-col">
            <div class="flex">
                <input class="w-1/3 border-r border-b border-t-0 border-l-0 rounded-tl-lg"
                    :disabled="disabled"
                    :class="{ 'highlight': highlight == 7, 'disabled': disabled }"
                    type="button" name="b7" value="7" @click="input(7)">
                <input class="w-1/3 border-r border-b border-t-0 border-l-0"
                    :disabled="disabled"
                    :class="{ 'highlight': highlight == 8, 'disabled': disabled }"
                    type="button" name="b8" value="8" @click="input(8)">
                <input class="w-1/3 border-r-0 border-b border-t-0 border-l-0 rounded-tr-lg"
                    :disabled="disabled"
                    :class="{ 'highlight': highlight == 9, 'disabled': disabled }"
                    type="button" name="b9" value="9" @click="input(9)">
            </div>
            
            <div class="flex">
                <input class="w-1/3 border-r border-b border-t-0 border-l-0"
                    :disabled="disabled"
                    :class="{ 'highlight': highlight == 4, 'disabled': disabled }"
                    type="button" name="b4" value="4" @click="input(4)">
                <input class="w-1/3 border-r border-b border-t-0 border-l-0"
                    :disabled="disabled"
                    :class="{ 'highlight': highlight == 5, 'disabled': disabled }"
                    type="button" name="b5" value="5" @click="input(5)">
                <input class="w-1/3 border-r-0 border-b border-t-0 border-l-0"
                    :disabled="disabled"
                    :class="{ 'highlight': highlight == 6, 'disabled': disabled }"
                    type="button" name="b6" value="6" @click="input(6)">
            </div>
            
            <div class="flex">
                <input class="w-1/3 border-r border-b border-t-0 border-l-0"
                    :disabled="disabled"
                    :class="{ 'highlight': highlight == 1, 'disabled': disabled }"
                    type="button" name="b1" value="1" @click="input(1)">
                <input class="w-1/3 border-r border-b border-t-0 border-l-0"
                    :disabled="disabled"
                    :class="{ 'highlight': highlight == 2, 'disabled': disabled }"
                    type="button" name="b2" value="2" @click="input(2)">
                <input class="w-1/3 border-r-0 border-b border-t-0 border-l-0"
                    :disabled="disabled"
                    :class="{ 'highlight': highlight == 3, 'disabled': disabled }"
                    type="button" name="b3" value="3" @click="input(3)">
            </div>
            
            <div class="flex">
                <input class="w-1/3 border-r border-b-0 border-t-0 border-l-0 rounded-bl-lg"
                    v-show="showComma"
                    :disabled="disabled"
                    :class="{ 'highlight': highlight == 11, 'disabled': disabled }"
                    type="button" name="b0" value="," @click="$emit('comma')">
                <input class="w-1/3 border-r border-b-0 border-t-0 border-l-0 rounded-bl-lg"
                    :disabled="disabled"
                    v-show="!showComma"
                    :class="{ 'highlight': highlight == 11, 'disabled': disabled }"
                    type="button" name="b0" value="Del" @click="$emit('clear')">
                <input class="w-1/3 border-r border-b-0 border-t-0 border-l-0"
                    :disabled="disabled"
                    :class="{ 'highlight': highlight == 0, 'disabled': disabled }"
                    type="button" name="potb" value="0" @click="input(0)">
                <input class="w-1/3 border-r-0 border-b-0 border-t-0 border-l-0 rounded-br-lg red text-2xl"
                    :disabled="disabled || !value"
                    :class="{ 'red-highlight': highlight == 10, 'red-disabled': disabled || !value }"
                    type="button" name="divb" value="Incluir" @click="$emit('commit')">
                <span class="key-hint cursor-pointer select-none"
                    @click="$emit('commit')">(ENTER)</span>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            disabled: Boolean,
            value: Number,
            leftToPay: Number,
        },
        data() {
            return {
                highlight: -1
            }
        },
        computed: {
            showComma () {
                return this.value % 1 == 0 && this.leftToPay != this.value;
            }
        },
        methods: {
            highlightNumber (number) {
                this.highlight = number;
                setTimeout(() => {
                    this.highlight = -1;
                }, 150)
            },
            input (value) {
                this.$emit('inputted', value);
            }
        },
    }
</script>

<style lang="scss" scoped>

.holder {
  position: relative;
  background: #f0f0f0;
  border-radius: 12px;
  width: 80%;
  max-width: 330px;
}

input[type=button] {
  height: calc(10vh - 10px);
  font-size: 30px;
  font-weight: 700;
  color: #303841;
  cursor: pointer;
  border-color: #ddd;
  border-style: solid;
}
input[type=button]:hover {
    background: #cfcfcf;
}
.highlight {
    background: #cfcfcf;
}
.red {
    color: white !important;
    background: #e04343;
}
.red:hover {
    background: #ff7b7b !important;
}
.red-highlight {
    background: #ff7b7b !important;
}
.disabled, .red-disabled {
    opacity: 0.5;
}
.disabled:hover {
    background: initial !important;
}
.red-disabled:hover {
    background: #e04343 !important;
}
.key-hint {
    position: absolute;
    right: 30px;
    bottom: 8px;
    color: white;
    font-size: 8pt;
}
</style>